import React from "react";

type AnimatedArrowsProps = {
  visible?: boolean;
};

/**
 * AnimatedArrows component displays sliding arrows that point toward
 * a target element (typically the countdown timer) when match grants are active.
 */
const AnimatedArrows = ({ visible = true }: AnimatedArrowsProps) => {
  if (!visible) return null;

  return (
    <>
      <style>
        {`
          @keyframes slide {
            0% {
              opacity: 0;
              transform: translateX(1vw);
            }
            40% {
              opacity: 0.6;
              transform: translateX(-1vw);
            }
            100% {
              opacity: 0;
              transform: translateX(-3vw);
            }
          }

          .animated-arrows-container {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 8px 0;
          }

          .animated-arrow {
            display: inline-block;
            font-size: 20px;
            color: #005A9C;
            animation: slide 1.5s infinite;
          }

          .animated-arrow:nth-child(1) {
            animation-delay: 0s;
          }

          .animated-arrow:nth-child(2) {
            animation-delay: 0.15s;
          }

          .animated-arrow:nth-child(3) {
            animation-delay: 0.3s;
          }
        `}
      </style>
      <div className="animated-arrows-container">
        <span className="animated-arrow">&lt;</span>
        <span className="animated-arrow">&lt;</span>
        <span className="animated-arrow">&lt;</span>
      </div>
    </>
  );
};

export default AnimatedArrows;
